import { createRouter, createWebHistory } from 'vue-router'

import Attachments from '@/pages/Attachments.vue'
import Dashboard from '@/pages/Dashboard.vue'
import Group from '@/pages/Group.vue'
import GroupList from '@/pages/GroupList.vue'
import ImportExport from '@/pages/ImportExport.vue'
import Login from '@/pages/Login.vue'
import ProgramPage from '@/pages/Program.vue'
import ProgramList from '@/pages/ProgramList.vue'
import ProgramVersion from '@/pages/ProgramVersion.vue'
import TarballList from '@/pages/TarballList.vue'
import UserEdit from '@/pages/UserEdit.vue'
import UserList from '@/pages/UserList.vue'
import { useApiStore } from '@/stores/api'

import type { NavigationGuard } from 'vue-router'

export enum RouteNames {
  DASHBOARD = 'dashboard',
  LOGIN = 'login',
  IMPORT_EXPORT = 'import-export',
  USER_LIST = 'user-list',
  USER_EDIT = 'user-edit',
  PROGRAM_LIST = 'program-list',
  PROGRAM_EDIT = 'program-edit',
  PROGRAM_VERSION = 'program-version',
  GROUP_LIST = 'group-list',
  GROUP_CREATE = 'group-create',
  GROUP_EDIT = 'group-edit',
  TARBALL_LIST = 'tarball-list',
  ATTACHMENTS = 'attachments'
}

const tokenMiddleware: NavigationGuard = () => {
  const apiStore = useApiStore()
  if (!apiStore.loggedIn) {
    return { name: RouteNames.LOGIN }
  }
}

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: RouteNames.LOGIN,
      component: Login,
      path: '/login',
    },
    {
      name: RouteNames.DASHBOARD,
      component: Dashboard,
      path: '/dashboard',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.IMPORT_EXPORT,
      component: ImportExport,
      path: '/import-export',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.USER_LIST,
      component: UserList,
      path: '/users',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.USER_EDIT,
      component: UserEdit,
      path: '/user/:id',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.GROUP_LIST,
      component: GroupList,
      path: '/groups',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.PROGRAM_LIST,
      component: ProgramList,
      path: '/programs',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.PROGRAM_VERSION,
      component: ProgramVersion,
      path: '/programs/:id/versions/:tag(.*)',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.PROGRAM_EDIT,
      component: ProgramPage,
      path: '/programs/:id',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.GROUP_CREATE,
      component: Group,
      path: '/groups/create',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.GROUP_EDIT,
      component: Group,
      path: '/groups/:id',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.TARBALL_LIST,
      component: TarballList,
      path: '/tarballs',
      beforeEnter: tokenMiddleware,
    },
    {
      name: RouteNames.ATTACHMENTS,
      component: Attachments,
      path: '/attachments',
      beforeEnter: tokenMiddleware,
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: {
        name: RouteNames.DASHBOARD,
        // https://github.com/vuejs/router/issues/1617#issuecomment-1320941431
        params: {},
      },
    },
  ],
  scrollBehavior () {
    return { left: 0, top: 0 }
  },
})
